export { default } from "./PercentQuestionCard"